/*
 * @providesModule BalanceBar
 *
 */

import React from 'react';
import {View} from 'react-native';

import ClientPropertyConstants from 'ClientPropertyConstants';
import BalanceBarV1 from 'BalanceBarV1'; // Silver Balance Bar
import BalanceBarV2 from 'BalanceBarV2'; // Tungsten Balance Bar
import BalanceBarV3 from 'BalanceBarV3'; // Bonus Cash Restriction Milestone 1 Balance Bar
import {SKZUserInterface} from 'SKZUser';

type State = {};

type chatSpotlightProps = {
  spotlightCornerRadiusChat: number;
  spotlightRefChat: number;
};

type Props = {
  shouldAnimate?: boolean;
  forceAnimation?: boolean;
  animationCurve?: string;
  animationDuration?: number;
  animationPrecisions?: {z: number; cash: number; ticketz: number};
  cashBalance: number;
  zBalance: number;
  ticketzBalance: number;
  currencyLayout?: (arg1: {
    nativeEvent: {
      layout: {
        x: number;
        y: number;
        width: number;
        height: number;
      };
    };
  }) => void;
  borderType?: 'surround' | 'divider' | 'none';
  borderColor?: string;
  currencyOrder?: string[];
  style?: Object;
  isTouchable?: boolean;
  disableEvents?: boolean;
  identifier?: string;
  showRightSideIcon?: boolean;
  showChatBadge?: boolean;
  overrideTheming?: boolean;
  lightThemeOverride?: boolean;
  /** this function when defined is a callback method for when the chat icon is available for education */
  onEducationChatSpotlightUpdated: (props: chatSpotlightProps) => {};
  /** This is a ref that gets assigned to the chat icon for education */
  educationChatRef: React.RefObject<View> | undefined;
  zCashRef: React.RefObject<View> | undefined;
  onClickZCurrency?: () => void;
  onClickTicketzCurrency?: () => void;
  onClickCashCurrency?: () => void;
  /** (Optional) will be called whenever the wallet tooltip is dismissed.
   * Used by Home screen to show other available tooltips after dismissing the wallet overlay
   */
  onDismissWalletTooltip?: () => void;
  showAddCashButton?: boolean;
  isContentCentered?: boolean;
  isNewHeaderEnabled?: boolean;
  isZCashCollapsed?: boolean;
  userInfo?: SKZUserInterface;
  medalBalance: number;
  screenName?: string;
};

export default class BalanceBar extends React.Component<Props, State> {
  static defaultProps: Partial<Props> = {
    shouldAnimate: false,
    forceAnimation: false,
    animationCurve: 'ease-in-ease-out',
    animationDuration: 300,
    borderType: 'none',
    borderColor: '#000000',
    showRightSideIcon: false,
    showChatBadge: false,
    overrideTheming: false,
    lightThemeOverride: false,
    isNewHeaderEnabled: false,
    isContentCentered: false,
    isZCashCollapsed: false,
  };

  render(): React.ReactElement {
    // Show new balance bar if user has Tungsten Core Loop
    if (
      ClientPropertyConstants.isCoreLoopTungstenEnabled() ||
      ClientPropertyConstants.isCoreLoopTungstenLiteEnabled()
    ) {
      if (this.props.isNewHeaderEnabled) {
        return <BalanceBarV3 {...this.props} />;
      } else {
        return <BalanceBarV2 {...this.props} />;
      }
    }
    // Show old balance bar if user has Silver
    return <BalanceBarV1 {...this.props} />;
  }
}
